import BlogVerticalCardList from "@components/BasicComponents/Cards/BlogCard/BlogVerticalCardList"
import PaginationWithFiltes from "@components/BasicComponents/PaginationWithFiltes/PaginationWithFiltes"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import {
	BlogPostModuleType,
	CategoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import styles from "./BlogListSection.module.scss"

export type BlogListSectionType = {
	data: BlogPostModuleType[]
	categories: CategoryModuleType[]
}

const BlogListSection = (props: BlogListSectionType) => {
	const [blogs, setBlogs] = useState<BlogPostModuleType[]>(props.data)

	const changeBlogs = (data: any[]) => {
		setBlogs(data)
	}

	return (
		<section>
			{/* Blog Posts Lists Cards */}
			{/* <Separator size={128} />
			<ContainerWrapper>
				<BlogVerticalCard data={props.data[0]} direction={"left"} />
			</ContainerWrapper> */}
			<Separator id={"startOfPagination"} size={32} />
			<ContainerWrapper>
				<PaginationWithFiltes
					changeData={changeBlogs}
					data={props.data}
					filters={[
						{
							category: {
								options: props.categories,
								type: "boxedSelect",
							},
						},
					]}
					postType={"News"}
				>
					<Separator className={styles.container}>
						{blogs?.map(
							(element: BlogPostModuleType, index: number) => {
								return (
									<Separator
										key={index}
										className={styles.wrapper}
										size={64}
										type={"padding"}
									>
										<BlogVerticalCardList
											data={element}
											direction={"right"}
										/>
									</Separator>
								)
							},
						)}
					</Separator>
				</PaginationWithFiltes>
			</ContainerWrapper>
			<Separator size={128} />
		</section>
	)
}

export default BlogListSection
